import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { UserLoginService } from '../service/cognito.service';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  invalidUsernameMsg: string;
  user: any = {
    username: ''
  };
  spammessage: boolean;
  constructor(private authService: AuthService, private router: Router,
    public userService: UserLoginService, private translate: TranslateService) { }


  ngOnInit() {
  }
  onFormSubmit(model: any, isValid: boolean) {
    if (!isValid) {
      return;
    }
    this.invalidUsernameMsg = null;
    this.userService.forgotPassword(this.user.username, this);
  }

  cognitoCallback(message: string, result: any) {
    if (message != null) { // error
      this.invalidUsernameMsg = message;
      if (message === 'Username/client id combination not found.') {
        this.translate.get('ForgotPassword.Userdeoesnotexits').subscribe(error => {
          this.invalidUsernameMsg = error;
        });
      }
    } else { // success
      // this.invalidUsernameMsg = 'Successfuly send to your email';
      this.spammessage = true;
      this.translate.get('ForgotPassword.Successfulysendyouremail').subscribe(error => {
        this.invalidUsernameMsg = error;
      });
      this.router.navigate(['/login/resetpassword']);
      // setTimeout(() => {
      // }, 1500);
    }
  }

  // Go to Login
  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// ./src/app/authentication/forget-password/forget-password.component.ts